import { getLocale } from "@/paraglide/runtime.js";

/** "October 29, 2026" in the language the site is read in. */
export const formatBlogDate = (iso: string | null) =>
  iso ? new Intl.DateTimeFormat(getLocale(), { day: "numeric", month: "long", year: "numeric" }).format(new Date(iso)) : "";

/** "3 minutes ago", "yesterday", or the date once it is more than a week old: when a comment was written. */
export const formatCommentTime = (iso: string, now = Date.now()) => {
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  const format = new Intl.RelativeTimeFormat(getLocale(), { numeric: "auto" });
  const abs = Math.abs(seconds);
  if (abs < 60) return format.format(0, "second");
  if (abs < 3600) return format.format(Math.round(seconds / 60), "minute");
  if (abs < 86_400) return format.format(Math.round(seconds / 3600), "hour");
  if (abs < 7 * 86_400) return format.format(Math.round(seconds / 86_400), "day");
  return formatBlogDate(iso);
};
